import { Outlet } from "react-router-dom";
import { Footer, Nav, ToastProvider } from "./design/components/index.js";

/**
 * Gemeinsame Huelle aller Ansichten.
 *
 * Die Sprungmarke steht bewusst als erstes fokussierbares Element: wer per
 * Tastatur navigiert, kommt damit an der Navigation vorbei direkt zum Inhalt.
 */
export function AppShell(): React.ReactElement {
  return (
    <ToastProvider>
      <a className="skip-link" href="#main">
        Zum Inhalt springen
      </a>
      <Nav />
      <main id="main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </ToastProvider>
  );
}
